/**
 * Iter94: Plan-Usage-Banner. Zeigt Verbrauch vs Limit + Upgrade-Hint.
 * Erscheint nur wenn (a) Beleg-Limit ≥80% erreicht, oder (b) Limit überschritten.
 */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { apiClient } from "@/lib/apiClient";
import { Sparkles, AlertTriangle } from "lucide-react";

export default function UsageBanner({ companyId, compact = false }) {
  const [usage, setUsage] = useState(null);

  useEffect(() => {
    if (!companyId) return;
    apiClient
      .get(`/companies/${companyId}/usage`)
      .then((r) => setUsage(r.data))
      .catch(() => setUsage(null));
  }, [companyId]);

  if (!usage) return null;
  const r = usage.receipts;
  if (r.limit === null) return null; // unlimited
  const pct = r.limit > 0 ? Math.min(100, Math.round((r.used / r.limit) * 100)) : 0;
  if (pct < 80) return null; // nicht zeigen wenn noch viel Platz

  const overLimit = r.is_at_limit;

  return (
    <div
      className={`flex items-center justify-between gap-3 px-3 py-2 rounded-md border flex-wrap ${
        overLimit
          ? "bg-rose-50 border-rose-200"
          : "bg-amber-50 border-amber-200"
      }`}
      data-testid="usage-banner"
    >
      <div className="flex items-start gap-2 min-w-0">
        {overLimit ? (
          <AlertTriangle className="h-4 w-4 text-rose-700 mt-0.5 flex-shrink-0" />
        ) : (
          <Sparkles className="h-4 w-4 text-amber-700 mt-0.5 flex-shrink-0" />
        )}
        <div className="min-w-0">
          <div className={`text-xs font-semibold ${overLimit ? "text-rose-900" : "text-amber-900"}`}>
            {overLimit
              ? `Beleg-Limit erreicht (${r.used}/${r.limit})`
              : `Beleg-Limit fast voll (${r.used}/${r.limit} · ${pct}%)`}
          </div>
          {!compact && (
            <div className={`text-[11px] ${overLimit ? "text-rose-700" : "text-amber-800"}`}>
              {overLimit
                ? `Neue Belege werden im '${usage.plan_name}'-Tarif aktuell blockiert. Upgrade um weiter zu arbeiten.`
                : `Im '${usage.plan_name}'-Tarif sind ${r.limit} Belege/Monat enthalten.`}
            </div>
          )}
        </div>
      </div>
      <Link
        to="/billing"
        className={`text-xs font-medium px-3 py-1.5 rounded-full whitespace-nowrap ${
          overLimit
            ? "bg-rose-600 hover:bg-rose-700 text-white"
            : "bg-amber-600 hover:bg-amber-700 text-white"
        }`}
        data-testid="usage-banner-upgrade-link"
      >
        Jetzt upgraden →
      </Link>
    </div>
  );
}
